'use strict';

import Vue from 'vue';
import App from './App.vue';

let el = document.getElementById('front-page-search');

if (el) {
    Vue.config.productionTip = false;

    new Vue({
        render: h => h(App)
    }).$mount('#front-page-search');
}
